import { TprmRequirementCategory } from '@evidentid/tprm-portal-lib/models/common';
import {
    TprmRequirementInstanceModel,
} from '@evidentid/tprm-portal-lib/models/common/TprmRequirementInstanceModel.model';
import { EvaluationResult } from '@evidentid/tprm-portal-lib/models/entity-details';
import { EntityRequirement } from '@evidentid/tprm-portal-lib/models/entity-details/EntityRequirement.model';
import { TprmRequirementModel } from '@evidentid/tprm-portal-lib/models/entity-details/TprmRequirementModel.model';

import { CategorizedEnumLabels } from '@/modules/dashboard/models/CategorizedEnumLabels.model';
import { FieldEvaluationResultError } from '@/modules/decisioning-criteria/types';
import {
    parseFieldValueByInstanceModel,
} from '@/modules/entity-details/components/Policy/utils/parse-field-value/parseFieldValueByInstanceModel';
import { EntityMultiFieldCriterion } from '@/modules/entity-details/types';

import { parseFieldValuePerEnumAndError } from './parseFieldValuePerEnumAndError';
import { parseFieldValuePerUiConversion } from './parseFieldValuePerUiConversion';

export function parseFieldValue(
    fieldName: string,
    fieldValue: unknown,
    otherData: {
        requirement: EntityRequirement;
        requirementModel?: TprmRequirementModel;
        requirementInstanceModels?: Record<TprmRequirementCategory, TprmRequirementInstanceModel[]>;
        evaluationResults: EvaluationResult[];
        evaluationErrors: Record<string, FieldEvaluationResultError>;
        multiFieldCriteria: EntityMultiFieldCriterion[];
        categorizedEnumLabels: CategorizedEnumLabels;
    }): any {
    let parsedValue = parseFieldValuePerUiConversion(fieldName, fieldValue);
    parsedValue = parseFieldValueByInstanceModel(fieldName, parsedValue, otherData.requirementInstanceModels);
    parsedValue = parseFieldValuePerEnumAndError(fieldName, parsedValue, {
        requirement: otherData.requirement,
        requirementModel: otherData.requirementModel,
        evaluationErrors: otherData.evaluationErrors,
        multiFieldCriteria: otherData.multiFieldCriteria,
        categorizedEnumLabels: otherData.categorizedEnumLabels,
    });
    return parsedValue;
}
